import { useState, useEffect } from "react";
import { CalendarDays } from "lucide-react";

export const FloatingTermine = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      const kontakt = document.getElementById("kontakt");
      if (!kontakt) return;
      const rect = kontakt.getBoundingClientRect();
      // hide when the contact/appointment section is on screen
      setShow(rect.top > window.innerHeight * 0.6);
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = () => document.getElementById("kontakt")?.scrollIntoView({ behavior: "smooth" });

  return (
    <button
      data-testid="floating-termine"
      onClick={go}
      aria-label="Termine vereinbaren"
      aria-hidden={!show}
      tabIndex={show ? 0 : -1}
      className={`fixed z-40 bottom-6 left-6 inline-flex items-center gap-2.5 rounded-full bg-charcoal text-gold-soft pl-5 pr-6 py-3.5 shadow-[0_18px_40px_-16px_rgba(44,38,33,0.8)] ring-1 ring-gold/30 transition-all duration-500 hover:bg-charcoal-soft ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <CalendarDays size={18} strokeWidth={1.75} />
      <span className="text-sm tracking-wide">Termine</span>
    </button>
  );
};
